class DrawerOverlay {
  constructor(drawer, templateDrawerItem) {
    this.drawer = drawer;
    this.loader = drawer.querySelector(".loader");
    this.templateDrawerItem = templateDrawerItem;
    this.itemManager = {}
    this.drawerPopup = this.drawer.querySelector("#popupDrawer");
    this.itemsContainer = this.drawer.querySelector(".items-container");
    this.drawerMessage = this.drawer.querySelector(".message");
    const drawerCloseBtn = this.drawer.querySelector(".drawer__close-button");
    this.drawer.addEventListener("click", (e) => {
      if (e.target !== this.drawer) return;
      this.closeDrawer();
    });
    if (drawerCloseBtn) {
      drawerCloseBtn.addEventListener("click", this.closeDrawer);
    }
  }
  renderItems(lineItems, drawerItems) {
    lineItems.forEach((lineItem) => {
      const { id, image, price, title, quantity, variantId } = lineItem;
      const item = this.templateDrawerItem.cloneNode(true);
      const productImage = item.querySelector("img");
      const productTitle = item.querySelector(".title");
      const productQuantity = item.querySelector(".quantity__input");
      const productPrice = item.querySelector(".price");

      productImage.src = image;
      productTitle.innerText = title;
      productQuantity.value = quantity;
      productQuantity.dataset.id = variantId;
      productQuantity.dataset.price = price * 100; //price was divided by 100
      productPrice.innerText = "$" + (price * quantity).toFixed(2);
      drawerItems.appendChild(item);
    });
  }
  getTotalPrice(lineItmes) {
    return lineItmes.reduce((total, item) => {
      return total + (item.price * item.quantity)
    }, 0);
  }
  renderDrawerContent(cart) {
    const lineItems = this.mapLineItmes(cart.items);
    const items_subtotal_price = cart.total_price / 100;
    const subtotalPrice = this.drawer.querySelector(".subtotal .price");
    const shippingPrice = this.drawer.querySelector(".shipping .price");
    const grandPrice = this.drawer.querySelector(".grandtotal .price");
    const drawerMessage = this.drawer.querySelector(".message");
    const orderDates = this.drawer.querySelector(".order-dates");
    const skipWeek = this.drawer.querySelector(".skip-week");
    const itemQuantity = this.drawer.querySelector(".item-quantity");

    itemQuantity.innerText = cart.item_count;
    subtotalPrice.textContent =
      "$" + parseFloat(items_subtotal_price).toFixed(2);

    var shippingTotal = 6.95;
    if(items_subtotal_price>=65){
      shippingTotal = "Free"
    }
    
      
    shippingPrice.textContent = "$" + shippingTotal;
    var totalPrice = items_subtotal_price
    if(shippingPrice != "Free"){
      totalPrice = (items_subtotal_price + shippingTotal)
    }
    grandPrice.innerText = "$" + parseFloat(totalPrice).toFixed(2);

    if (lineItems.length == 0) {
      drawerMessage.textContent = "YOUR CART IS EMPTY";
    } else {
      const awayFromFreeDelevery = (65 - items_subtotal_price);

      if (awayFromFreeDelevery > 0) {
        const formatedPrice = "$" + parseFloat(awayFromFreeDelevery).toFixed(2);
        drawerMessage.innerHTML = `ONLY <span class="red-price">${formatedPrice}</span> AWAY FROM FREE DELIVERY`;
      } else {
        drawerMessage.innerHTML = "";
      }
    }

    this.itemsContainer.innerHTML = "";
    this.renderItems(lineItems, this.itemsContainer);
    if (this.itemManager.customerId) {
      const arrivingDate = orderDates.querySelector(".arriving-date");
      const changable = orderDates.querySelector(".changeable");
      const { nextBillingDate } = this.itemManager.subscriptionCache.data;
      const billingDate = new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
      }).format(new Date(nextBillingDate));

      //insert the actual date
      const changableUntilDate = new Date(nextBillingDate);
      changableUntilDate.setDate(changableUntilDate.getDate()); //Charge Date

      const arriveDateActual = new Date(nextBillingDate);
      arriveDateActual.setDate(arriveDateActual.getDate() + 4);


      const arriveDateActualDay = new Intl.DateTimeFormat("en", {
        weekday: "long",
        month: "long",
        day: "numeric",
      }).format(arriveDateActual);
      arrivingDate.innerText = arriveDateActualDay;

      const changableUntilWeekday = new Intl.DateTimeFormat("en", {
        weekday: "long",
      }).format(changableUntilDate); //get weekday
      const changableUntilTime = new Intl.DateTimeFormat("en", {
        hour: "numeric",
        minute: "numeric",
      }).format(changableUntilDate); //get hour and mintue

      changable.innerHTML = `Changable until ${changableUntilWeekday} at ${changableUntilTime}`;
      const bannerOrderDates = document.querySelector(
        ".subscription-banner .order-dates"
      );

      bannerOrderDates.replaceWith(orderDates.cloneNode(true));

      orderDates.style.display = "block";
      skipWeek.style.display = "block";
    } else {
      orderDates.style.display = "none";
      skipWeek.style.display = "none";
    }
  }
  openDrawer() {
    this.itemsContainer.innerHTML = "";
    this.drawerMessage.innerHTML = "";
    this.drawer.style.display = "block";
    this.loader.style.display = "grid";
    this.drawerPopup.style.display = "flex";

    const fetchOptions = {
      credentials: 'same-origin',
      cache: 'no-store'
    }

    fetch("/cart.js", fetchOptions)
      .then((response) => response.json())
      .then((cart) => {
        this.loader.style.display = "none"
        this.renderDrawerContent(cart)
      });
  }
  mapLineItmes(items) {
    return items.map(item => ({
      id: item.id,
      variantId: item.variant_id,
      price: item.final_price / 100,
      quantity: item.quantity,
      image: item.image,
      title: item.title
    }))
  }
  closeDrawer() {
    this.drawerPopup = document.querySelector("#popupDrawer");
    this.drawerPopup.classList.add("closing-drawer");
    setTimeout(() => {
      this.drawerPopup.classList.remove("closing-drawer");
      this.drawerPopup.style.display = "none";
      if (!this.drawer) {
        this.drawer = document.querySelector(".drawer-overlay")
      }
      this.drawer.style.display = "none";
    }, 500);
  };
}

const drawerTemplate = document.getElementById('drawerOverlayTemplate');
const templateDrawer = drawerTemplate.content.querySelector('.drawer-overlay');
const drawerItemTemplate = document.getElementById('drawerItemTemplate');
this.templateDrawerItem = drawerItemTemplate.content.querySelector(".item");
const drawer = templateDrawer.cloneNode(true);
document.body.appendChild(drawer)
const drawerOverlay = new DrawerOverlay(drawer, templateDrawerItem);

class DrawerCloseButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", drawerOverlay.closeDrawer);
  }
}
customElements.define("drawer-close-button", DrawerCloseButton);

class DrawerOpenButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => {
      drawerOverlay.openDrawer()
    });
  }
  fetchCartItems() {
    const itemsContainer = document.getElementById("itemsContainer");
    const loading = itemsContainer.appendChild(document.createElement("h2"));
    loading.className = "loading";
    loading.innerText = "loading...";
    fetch("/cart.js", {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then((response) => response.json())
      .then((data) => {
        loading.remove();
        drawerOverlay.openDrawer(data)
      });
  }
}
customElements.define("drawer-open-button", DrawerOpenButton);

function formatPrice(price) {
  return "$" + parseFloat(price / 100).toFixed(2);
}
